export default __webpack_public_path__ + "static/media/cert-general-staff-a-HKIRC-sc.7bdeeb19.jpg";